import { apiFetch } from "./apiClient";

export async function getDeviceMapData(rcDeviceId) {
  const res = await apiFetch(`/api/v1/list-maps/${rcDeviceId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device map data");
  }
  return res.json();
}

export async function getDeviceZoneGroups(rcDeviceId) {
  const res = await apiFetch(`/api/v1/list-zone-groups/${rcDeviceId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device zone groups");
  }
  return res.json();
}

export async function getDeviceZones(rcDeviceId) {
  const res = await apiFetch(`/api/v1/list-zones/${rcDeviceId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device zones");
  }
  return res.json();
}

export async function createOrUpdateZoneGroup(zoneGroupData) {
  const res = await apiFetch(`/api/v1/zone-group`, {
    method: "POST",
    body: JSON.stringify(zoneGroupData),
  });
  if (!res.ok) {
    throw new Error("Failed to create or update zone group");
  }
  const data = await res.json();
  return { success: true, data };
}

export async function updateZoneGroupStatus({
  deviceId,
  zoneGroupPkId,
  active,
}) {
  const res = await apiFetch(`/api/v1/zone-group/status`, {
    method: "PATCH",
    body: JSON.stringify({ deviceId, zoneGroupPkId, active }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to update zone group status",
    };
  }
  const data = await res.json();
  return { success: true, data };
}

export async function deleteZoneGroup({ deviceId, zoneGroupPkId }) {
  const res = await apiFetch(`/api/v1/zone-group`, {
    method: "DELETE",
    body: JSON.stringify({ deviceId, zoneGroupPkId }),
  });
  if (!res.ok) {
    const errorData = await res.json();
    return {
      success: false,
      error: errorData.error || "Failed to delete zone group",
    };
  }
  const data = await res.json();
  return { success: true, data };
}
